import scrollTo from 'lib/scrollToElement';

const globalNavThreshold = 600;
const globalNavHeights = {
  news: 80,
  default: 50,
};
const localNavHeight = 80;

function removeAllHighlights() {
  const highlighted = document.querySelectorAll('.componentHighlight');
  Array.from(highlighted).forEach((el) => el.classList.remove('componentHighlight'));
  const curatorOverlays = document.querySelectorAll('span.curatorOverlay');
  Array.from(curatorOverlays).forEach((el) => el.remove());
}

function listenForCurationMessages(vertical, fetchDraft) {
  window.addEventListener('message', (event) => {
    const { data, data: { payload = {} } } = event;

    if (data === 'curationPing') {
      // Tell preview it supports postMessage reloading
      window.parent.postMessage('curationPing', '*');
    }

    if (data === 'refreshFront') {
      fetchDraft();
      window.parent.postMessage('refreshingFront', '*');
    }

    if (data.type === 'scrollTo') {
      const targetDiv = document.querySelector(`[data-packageid='${payload.packageId}'] [data-contentid='${payload.contentId}']`)
        || document.querySelector(`[data-packageid='${payload.packageId}']`);

      if (targetDiv) {
        let topHeight = targetDiv.getBoundingClientRect().top;
        topHeight += document.documentElement.scrollTop;

        // Global nav will disappear when this height is scrolled to
        const isPastThreshold = topHeight > globalNavThreshold;

        const globalNavHeight = globalNavHeights[vertical] || globalNavHeights.default;
        topHeight -= localNavHeight + (isPastThreshold ? 0 : globalNavHeight);

        scrollTo(topHeight - 5, 500, 'easeInOut', () => {
          scrollTo(topHeight, 0); // ensure final scroll is down
        });
      }
    }

    if (data.type === 'highlight') {
      // Remove all highlights
      removeAllHighlights();

      // Add new highlight
      const highlightDiv = document.querySelector(`[data-packageid='${payload.packageId}'] [data-contentid='${payload.contentId}']`)
        || document.querySelector(`[data-packageid='${payload.packageId}']`);
      if (highlightDiv) {
        highlightDiv.classList.add('componentHighlight');
        const curatorOverlay = document.createElement('span');
        curatorOverlay.classList.add('curatorOverlay');
        highlightDiv.append(curatorOverlay);
      }
    } else if (data.type === 'stopHighlight') {
      const stopHighlightDiv = document.querySelector(`[data-packageid='${payload.packageId}'] [data-contentid='${payload.contentId}']`)
        || document.querySelector(`[data-packageid='${payload.packageId}']`);

      if (stopHighlightDiv) {
        stopHighlightDiv.classList.remove('componentHighlight');
        const overlay = stopHighlightDiv.querySelector('span.curatorOverlay');
        if (overlay) overlay.remove();
      } else {
        removeAllHighlights();
      }
    }
  });
}

export default listenForCurationMessages;
